import React, { useState } from 'react';

const Contact = () => {
  // ... (keeping state and handlers as they were)
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    fetch('/send_email.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
    .then(response => response.json())
    .then(data => {
      if (data.sent) {
        alert('Thank you for contacting Nevis Trust Services Limited. A representative will be in touch shortly.');
        setFormData({ name: '', email: '', phone: '', service: '', message: '' });
      } else {
        alert('There was an error sending your message. Please try again later.');
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      alert('There was an error sending your message. Please try again later.');
    });
  };

  return (
    <div className="contact-page" style={{backgroundColor: 'var(--bg-dark)'}}>
      <div className="page-header" style={{backgroundImage: "url('https://images.unsplash.com/photo-1505330622279-bf7d7fc918f4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')"}}>
        <div className="page-header-overlay"></div>
        <div className="container page-header-content">
          <h1 className="fw-bold">Contact Us</h1>
          <p className="description">Start Your Journey to Secure Wealth Management</p>
        </div>
      </div>

      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-5">
            <div className="pe-lg-4">
               <h2 className="text-white fw-bold mb-4" style={{fontFamily: 'var(--font-serif)'}}>Get in Touch</h2>
               <p className="lead mb-4">
                 We value your interest in Nevis Trust Services Limited. Please use the form to submit your inquiry, and our team will respond with the utmost discretion.
               </p>

               <div className="d-flex mb-4 align-items-start">
                  <i className="bi bi-geo-alt-fill fs-4 text-accent me-3"></i>
                  <div>
                    <h5 className="fw-bold text-white mb-1">Office Address</h5>
                    <p className="text-muted mb-0">
                      Jessups Estate,<br/>
                      Nevis, St. Kitts and Nevis
                    </p>
                  </div>
               </div>

               <div className="d-flex mb-4 align-items-start">
                  <i className="bi bi-telephone-fill fs-4 text-accent me-3"></i>
                  <div>
                    <h5 className="fw-bold text-white mb-1">Phone</h5>
                    <p className="text-muted mb-0">
                      +1 (850) 364-0560<br/>
                      <small>Monday - Friday, 9:00 AM - 5:00 PM AST</small>
                    </p>
                  </div>
               </div>

               <div className="d-flex mb-4 align-items-start">
                  <i className="bi bi-envelope-fill fs-4 text-accent me-3"></i>
                  <div>
                    <h5 className="fw-bold text-white mb-1">Email</h5>
                    <p className="text-muted mb-0">
                      consult@skntrust.com
                    </p>
                  </div>
               </div>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="p-4 p-md-5 border border-secondary" style={{backgroundColor: 'var(--bg-panel)'}}>
              <h3 className="fw-bold text-accent mb-4" style={{fontFamily: 'var(--font-serif)'}}>Consultation Request</h3>
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label text-accent fw-bold small">Full Name</label>
                    <input 
                      type="text" 
                      className="form-control p-3" 
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required 
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-accent fw-bold small">Email Address</label>
                    <input 
                      type="email" 
                      className="form-control p-3" 
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required 
                    />
                  </div>
                   <div className="col-md-6">
                    <label className="form-label text-accent fw-bold small">Phone Number</label>
                    <input 
                      type="tel" 
                      className="form-control p-3" 
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-accent fw-bold small">Service of Interest</label>
                    <select 
                      className="form-select p-3"
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                    >
                      <option value="">Select a Service...</option>
                      <option value="Citizenship">Citizenship by Investment</option>
                      <option value="LLC/IBC">LLC & IBC Formation</option>
                      <option value="Trusts">Trust Registration</option>
                      <option value="Trustee">Trustee/Nominee Services</option>
                      <option value="Agent">Registered Agent Services</option>
                      <option value="Acquisitions">Acquisitions</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="col-12">
                    <label className="form-label text-accent fw-bold small">Message</label>
                    <textarea 
                      className="form-control p-3" 
                      rows="5"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  <div className="col-12">
                    <button type="submit" className="btn btn-primary w-100 py-3 fw-bold text-uppercase letter-spacing-2">
                      Submit Inquiry
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
